import { render, staticRenderFns } from "./EmailPanel.vue?vue&type=template&id=21a4aa4c&scoped=true&"
import script from "./EmailPanel.vue?vue&type=script&lang=ts&"
export * from "./EmailPanel.vue?vue&type=script&lang=ts&"
import style0 from "./EmailPanel.vue?vue&type=style&index=0&id=21a4aa4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a4aa4c",
  null
  
)

export default component.exports